/** True on a touch handset where `tel:` actually opens a dialer. */
export const isTelCapable = () => {
  if (typeof window === "undefined") return false;
  const ua = window.navigator.userAgent || "";
  return /iPhone|iPad|iPod|Android/i.test(ua);
};

export const stripTel = (value: string) => value.replace(/[^\d+]/g, "");

/** True when this visitor can dial the number straight from the page. */
export const canDialFromDevice = (phoneNumber?: string | null): phoneNumber is string =>
  !!phoneNumber && isTelCapable();
